import React from 'react';
import { ShieldCheck, CheckCircle2, AlertCircle, Clock } from 'lucide-react';
export const VerificationBadge = ({
  status,
  type = 'property'
}: {
  status: 'Approved' | 'Pending' | 'Rejected' | 'Unverified';
  type?: 'property' | 'seller';
}) => {
  if (status === 'Approved') {
    return <div className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-success/10 text-success text-xs font-medium border border-success/20" data-id="element-153">
        {type === 'property' ? <ShieldCheck size={14} data-id="element-154" /> : <CheckCircle2 size={14} data-id="element-155" />}
        <span data-id="element-156">Verified {type === 'property' ? 'Listing' : 'Seller'}</span>
      </div>;
  }
  if (status === 'Pending') {
    return <div className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-secondary/10 text-secondary-dark text-xs font-medium border border-secondary/20" data-id="element-157">
        <Clock size={14} data-id="element-158" />
        <span data-id="element-159">Verification Pending</span>
      </div>;
  }
  if (status === 'Rejected') {
    return <div className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-error/10 text-error text-xs font-medium border border-error/20" data-id="element-160">
        <AlertCircle size={14} data-id="element-161" />
        <span data-id="element-162">Verification Failed</span>
      </div>;
  }
  return <div className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-neutral-dark/10 text-neutral-dark text-xs font-medium border border-neutral-dark/20" data-id="element-163">
      <AlertCircle size={14} data-id="element-164" />
      <span data-id="element-165">Unverified</span>
    </div>;
};
export const TierBadge = ({
  tier
}: {
  tier: 1 | 2 | 3;
}) => {
  const config = {
    1: {
      bg: 'bg-secondary',
      text: 'text-white',
      label: 'Tier 1',
      border: 'border-secondary-light'
    },
    2: {
      bg: 'bg-primary-900',
      text: 'text-white',
      label: 'Tier 2',
      border: 'border-primary-800'
    },
    3: {
      bg: 'bg-neutral-light',
      text: 'text-text-light',
      label: 'Tier 3',
      border: 'border-neutral'
    }
  };
  const {
    bg,
    text,
    label,
    border
  } = config[tier];
  return <div className={`inline-flex items-center px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider ${bg} ${text} border ${border} shadow-sm`} data-id="element-166">
      {label}
    </div>;
};